import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import UserSignIn from '../users/userSignIn';
import ReminderPage from '../reminders/reminder';
import NurseSearch from '../nurses/nurseSearch';
import NurseFormWrapper from '../nurses/nurseFormWrapper';
import ServiceSearch from '../services/serviceSearch';
import ServiceFormWrapper from '../services/serviceFormWrapper';
import ServiceBookingSearch from '../nurse-service-bookings/serviceBookingSearch';
import ServiceBookingFormWrapper from '../nurse-service-bookings/serviceBookingFormWrapper';
import EmployeeSearch from '../usys-employees/employeeSearch';
import EmployeeFormWrapper from '../usys-employees/employeeFormWrapper';
import { FormMode } from '../utils/extensions/constantEx'

const PageLoader = () => {
    return (
        <Box sx={{ width: '100%' }}>
            <LinearProgress />
        </Box>
    );
}

export default function PageRoute() {

    return (
        <React.Fragment>
            <Routes>
                {/* <Route path="/" element={<Navigate to="/user-login" replace={true} />} /> */}

                <Route
                    path="user-login"
                    element={
                        <React.Suspense fallback={<PageLoader />}>
                            <UserSignIn />
                        </React.Suspense>
                    }
                />

                <Route
                    path="reminder"
                    element={
                        <React.Suspense fallback={<PageLoader />}>
                            <ReminderPage />
                        </React.Suspense>
                    }
                />

                <Route
                    path="/search-nurses"
                    element={
                        <React.Suspense fallback={<PageLoader />}>
                            <NurseSearch />
                        </React.Suspense>
                    }
                />

                <Route
                    path="/nurse-form"
                    element={
                        <React.Suspense fallback={<PageLoader />}>
                            <NurseFormWrapper formMode={FormMode.NewMode} />
                        </React.Suspense>
                    }
                />

                <Route
                    path="/search-services"
                    element={
                        <React.Suspense fallback={<PageLoader />}>
                            <ServiceSearch />
                        </React.Suspense>
                    }
                />

                <Route
                    path="/service-form"
                    element={
                        <React.Suspense fallback={<PageLoader />}>
                            <ServiceFormWrapper formMode={FormMode.NewMode} />
                        </React.Suspense>
                    }
                />

                <Route
                    path="/nurse-service-booking"
                    element={
                        <React.Suspense fallback={<PageLoader />}>
                            <ServiceBookingSearch />
                        </React.Suspense>
                    }
                />

                <Route
                    path="/nurse-service-booking-form"
                    element={
                        <React.Suspense fallback={<PageLoader />}>
                            <ServiceBookingFormWrapper formMode={FormMode.NewMode} selectedId={0} />
                        </React.Suspense>
                    }
                />

                <Route
                    path="/search-employees"
                    element={
                        <React.Suspense fallback={<PageLoader />}>
                            <EmployeeSearch />
                        </React.Suspense>
                    }
                />

                <Route
                    path="/employee-form"
                    element={
                        <React.Suspense fallback={<PageLoader />}>
                            <EmployeeFormWrapper formMode={FormMode.NewMode} />
                        </React.Suspense>
                    }
                />

            </Routes>
        </React.Fragment>
    );
}